import * as React from 'react';
import { Button, Tooltip } from '@cian/ui-kit';

import {
  ADD_TO_COMPARE_LABEL,
  ADD_TO_COMPARE_TOOLTIP,
  COMPARE_BUTTON_DATA_MARK,
  REMOVE_FROM_COMPARE_LABEL,
  REMOVE_FROM_COMPARE_TOOLTIP,
} from './constants/compare';
import { IconActionCompareAdd24, IconActionCompareAdded24 } from '@cian/ui-kit-design-tokens/icons';

interface ICompareButtonWithTooltipProps {
  isAdded: boolean;
  onClick(): void;
}

export function CompareButtonWithTooltip({ isAdded, onClick }: ICompareButtonWithTooltipProps) {
  return (
    <Tooltip placement="left" title={isAdded ? REMOVE_FROM_COMPARE_TOOLTIP : ADD_TO_COMPARE_TOOLTIP}>
      <Button
        beforeIcon={
          isAdded ? (
            <IconActionCompareAdded24 color="icon-main-default" />
          ) : (
            <IconActionCompareAdd24 color="icon-primary-default" />
          )
        }
        theme="stroke_secondary"
        size="M"
        onClick={onClick}
        data-mark={COMPARE_BUTTON_DATA_MARK}
        aria-label={isAdded ? REMOVE_FROM_COMPARE_LABEL : ADD_TO_COMPARE_LABEL}
      />
    </Tooltip>
  );
}
